import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import { useMsal } from '@azure/msal-react';

import { getAvailableTenants, getTenantName } from '../../utils/tokenUtils';
import { performTenantSwitch } from '../../utils/tenantSwitchUtils';

import logo from '../../assets/img/logo-dark.png';
import logoBlank from '../../assets/img/logo-blank.png'; // white, the old BioMADE logo's size, so the Telescope logo stays put

const SelectTenantPage = () => {
    const navigate = useNavigate();
    const { instance } = useMsal();

    const [tenants, setTenants] = useState([]);
    const [switchingTo, setSwitchingTo] = useState(null); // tenantname currently being switched to
    const [error, setError] = useState(null);

    useEffect(() => {
        const available = getAvailableTenants();
        if (!available || available.length === 0) {
            // Nothing to choose — go straight to landing
            navigate('/landing', { replace: true });
            return;
        }
        setTenants(available);
    }, [navigate]);

    const handleSelect = async (tenantName) => {
        setError(null);
        setSwitchingTo(tenantName);
        const success = await performTenantSwitch(instance, tenantName);
        if (success) {
            navigate('/landing', { replace: true });
        } else {
            setError(`Could not switch to "${tenantName}". Please try again or contact your administrator.`);
            setSwitchingTo(null);
        }
    };

    const currentTenant = getTenantName();

    return (
        <>
            <Container>
                <img
                    className="brand-img img-fluid mt-10"
                    style={{ display: 'block', maxWidth: '10%', height: 'auto', margin: '0 auto' }}
                    src={logoBlank}
                    alt=""
                />
                <img
                    className="brand-img img-fluid"
                    style={{ display: 'block', maxWidth: '35%', height: 'auto', margin: '0 auto', marginTop: '-60px' }}
                    src={logo}
                    alt="Telescope"
                />
            </Container>

            <Container className="mt-4">
                <Row>
                    <Col xxl={5} xl={7} lg={10} className="mx-auto">
                        <Card className="text-center">
                            <Card.Body>
                                <Card.Title>
                                    <h3>Select Your Organization</h3>
                                </Card.Title>
                                <p className="text-muted mb-4">
                                    Your account has access to multiple organizations. Choose which one to sign in to.
                                </p>

                                {error && (
                                    <Alert variant="danger" className="text-start mb-3">
                                        {error}
                                    </Alert>
                                )}

                                <div className="d-grid gap-2">
                                    {tenants.map(({ tenantname }) => {
                                        const isActive = tenantname === currentTenant;
                                        const isLoading = switchingTo === tenantname;
                                        const isDisabled = switchingTo !== null;

                                        return (
                                            <Button
                                                key={tenantname}
                                                variant={isActive ? 'primary' : 'outline-secondary'}
                                                disabled={isDisabled}
                                                onClick={() => handleSelect(tenantname)}
                                                className="d-flex align-items-center justify-content-between px-4"
                                            >
                                                <span>{tenantname}</span>
                                                {isActive && !isLoading && (
                                                    <i className="ri-checkbox-circle-fill ms-2" />
                                                )}
                                                {isLoading && (
                                                    <span
                                                        className="spinner-border spinner-border-sm ms-2"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                )}
                                            </Button>
                                        );
                                    })}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default SelectTenantPage;
